import React from "react";

function SearchButton(props: React.ComponentPropsWithoutRef<"button">) {
    const defaultBtnClass: string = 'buttonDefault transition500';

    return (
        <div className="formContent bxd2 bxm12">
            <div className="buttonDefaultContainer">
                <button {...props}
                        className={props.disabled ? `${defaultBtnClass} darkBtn` : defaultBtnClass}
                        disabled={props.disabled}>
                    Rechercher
                </button>
            </div>
        </div>
    )
}

export default SearchButton;
